import React from "react";
import {
  Dialog,
  DialogContent,
  IconButton,
  Box,
  Typography,
} from "@mui/material";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import { Icon } from "../../icons";
import { IconZoomIn, IconZoomOut, IconRefresh } from "@tabler/icons-react";
import { COLORS } from "../../constants/color";

const ImagePreviewModal = ({ open, onClose, imageUrl, title }) => {
  if (!imageUrl) return null;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="lg"
      fullWidth
      PaperProps={{
        sx: {
          bgcolor: "transparent",
          boxShadow: "none",
          overflow: "hidden",
        },
      }}
    >
      <Box
        sx={{
          position: "relative",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          height: "90vh",
          width: "100%",
        }}
      >
        {/* Header/Actions */}
        <Box
          sx={{
            position: "absolute",
            top: 16,
            right: 16,
            zIndex: 10,
            display: "flex",
            gap: 1,
          }}
        >
          <IconButton
            onClick={onClose}
            sx={{
              bgcolor: "rgba(0,0,0,0.5)",
              color: "#fff",
              "&:hover": { bgcolor: "rgba(0,0,0,0.7)" },
            }}
          >
            <Icon name="close" size={24} />
          </IconButton>
        </Box>

        {/* Image Display */}
        <DialogContent
          sx={{
            p: 0,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            height: "100%",
            overflow: "hidden",
          }}
        >
          <TransformWrapper
            initialScale={1}
            minScale={0.5}
            maxScale={5}
          >
            {({ zoomIn, zoomOut, resetTransform }) => (
              <React.Fragment>
                {/* Controls */}
                <Box
                  sx={{
                    position: "absolute",
                    bottom: 24,
                    left: "50%",
                    transform: "translateX(-50%)",
                    zIndex: 10,
                    display: "flex",
                    gap: 2,
                    bgcolor: "rgba(0,0,0,0.6)",
                    px: 3,
                    py: 1,
                    borderRadius: 10,
                    backdropFilter: "blur(4px)",
                  }}
                >
                  <IconButton onClick={() => zoomIn()} sx={{ color: "#fff" }}>
                    <IconZoomIn size={24} />
                  </IconButton>
                  <IconButton onClick={() => zoomOut()} sx={{ color: "#fff" }}>
                    <IconZoomOut size={24} />
                  </IconButton>
                  <IconButton onClick={() => resetTransform()} sx={{ color: "#fff" }}>
                    <IconRefresh size={24} />
                  </IconButton>
                </Box>

                <TransformComponent
                  wrapperStyle={{
                    width: "100%",
                    height: "100%",
                  }}
                  contentStyle={{
                    width: "100%",
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Box
                    component="img"
                    src={imageUrl}
                    alt={title || "Preview"}
                    sx={{
                      maxWidth: "100%",
                      maxHeight: "80vh",
                      objectFit: "contain",
                      boxShadow: "0 8px 32px rgba(0,0,0,0.4)",
                      borderRadius: 1,
                    }}
                  />
                </TransformComponent>
              </React.Fragment>
            )}
          </TransformWrapper>
        </DialogContent>

        {title && (
          <Box
            sx={{
              position: "absolute",
              bottom: 80,
              left: "50%",
              transform: "translateX(-50%)",
              zIndex: 10,
              bgcolor: "rgba(0,0,0,0.5)",
              color: "#fff",
              px: 3,
              py: 1,
              borderRadius: 2,
              textAlign: "center",
              maxWidth: "80%",
            }}
          >
            <Typography variant="body1">{title}</Typography>
          </Box>
        )}
      </Box>
    </Dialog>
  );
};

export default ImagePreviewModal;
